import { type ClassNameValue, twMerge } from 'tailwind-merge'

export function twm(...classNames: ClassNameValue[]): string {
  // Check if we need to use tailwind merge at all
  const classes = classNames.filter((x): x is string => Boolean(x))
  // If all falsy, no need to run twMerge
  if (classes.length === 0) return ''
  // If only one set of classes, also no need to run twMerge, your editor will
  // whine at you if you used the same class twice
  if (classes.length === 1 && classes[0]) return classes[0]

  return twMerge(classes)
}
